import { isGraphQLType } from './types'

/**
 * Transforms upperLimit based on amount strategy type:
 * - Fixed compensations: returns undefined (no upperLimit field)
 * - Variable compensations: returns the limit value or null if no limit
 */
export function manageUpperLimit(
  amountStrategy: { __typename?: string; upperLimit?: number | null } | null | undefined
): number | null | undefined {
  if (isGraphQLType(amountStrategy, 'ContractsVariableAmountStrategy')) {
    return amountStrategy.upperLimit || null
  }
  return undefined
}
